import { render } from "./fieldCultivation.vue?vue&type=template&id=25040142&scoped=true"
const script = {}

import "./fieldCultivation.vue?vue&type=style&index=0&id=25040142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25040142"]])

export default __exports__